import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import VueQRCodeComponent from 'vue-qr-generator'

import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'

import socket from './socket';
import { EventBus } from './event-bus';


// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

// Axios Mock Adapter
import '@/@fake-db/db'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)
Vue.component('qr-code', VueQRCodeComponent);

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

// ให้เรียก socket ได้จากทุก component ผ่าน this.$socket
Vue.prototype.$socket = socket;

// ฟัง event จาก backend แล้วเด้ง toast ทันที
socket.on('connect', () => {
 
 // EventBus.$emit('notify', { title: 'Socket', message: 'Connected', type: 'success', duration: 1200 });
});
socket.onAny((event, ...args) => {
  //console.log('📩 socket onAny:', event, args);
});
socket.on('connect_error', (err) => {
  console.log('❌ socket connect_error:', err.message);
});
socket.on('disconnect', () => {
  //EventBus.$emit('notify', { title: 'Socket', message: 'Disconnected', type: 'warning', duration: 1500 });
});

socket.on('notification', (data) => {
  // data = { message, type }
  EventBus.$emit('notify', {
    title: 'Realtime',
    message: data?.message || 'New notification',
    type: data?.type || 'info',
  });
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
